import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import Home from "./components/Home";
import About from "./components/About";
import Registration from "./components/Registration";
import Book from "./components/Book";
import Abstract from "./components/Abstract";
import Executive from "./components/Executive";
import Contact from "./components/Contact";
import Social from "./components/Social";
import Speaker from "./components/Speakers";
import Scientific from "./components/Scientific";
import Sponsors from "./components/Sponsors"; 
import "./App.css";

/* Import your Program PDF */
import programmePDF from "./images/VetEd_Africa_Scientific_Program_VF.pdf";

import globalLogo from "./images/logo_global.png";
import ampaMark from "./images/sponsors/ampa-mark.webp";

function App() {
  // 1. État pour suivre la section actuellement visible à l'écran
  const [activeSection, setActiveSection] = useState("home");

  // 2. Logique d'écoute du défilement (ScrollSpy)
  useEffect(() => {
    const handleScroll = () => {
      // Liste de toutes les sections dans l'ordre de la page
      const sections = [
        "home", "about", "registration", "abstract", "book",
        "executive", "scientific",
        "speakers", "sponsors", "social", "contact"
      ];

      let current = "home";

      sections.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          // On vérifie la position de l'élément par rapport au haut de l'écran (offset de 150px pour la navbar)
          const rect = element.getBoundingClientRect();
          if (rect.top <= 150) {
            current = id;
          }
        }
      });

      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Exécuter une fois au chargement

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Condition spéciale : le menu "Committees" doit être actif si l'un de ses 3 sous-comités est à l'écran
  const isCommitteeActive = ["executive", "scientific"].includes(activeSection);

  return (
    <div>
      {/* Top Navigation Bar */}
      <Navbar bg="light" expand="xl" fixed="top" className="veted-navbar">
        <Container fluid className="px-2 px-md-4">
          {/* Brand / Logos: partner banner + AMPA sponsor emblem */}
          <div className="brand-group">
            <Navbar.Brand href="#home" className="d-flex align-items-center global-brand">
              <img src={globalLogo} alt="VETEd Africa partner logos" className="global-logo" />
            </Navbar.Brand>
            <a href="#ampa" className="ampa-nav-logo" title="AMPA — Sponsoring Organization">
              <img src={ampaMark} alt="AMPA — Moroccan Association of Avian Pathology" />
            </a>
          </div>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto nav-inline align-items-center">
              {/* Utilisation de la prop "active" liée à notre état de scroll */}
              <Nav.Link href="#home" active={activeSection === "home" || activeSection === "about"}>Home</Nav.Link>
              <Nav.Link href="#registration" active={activeSection === "registration"}>Fees</Nav.Link>
              <Nav.Link href="#abstract" active={activeSection === "abstract"}>Abstract Submission</Nav.Link>
              <Nav.Link href="#book" active={activeSection === "book"}>Registration</Nav.Link>
              
              <NavDropdown 
                title="Committees" 
                id="committees-dropdown" 
                className="hover-dropdown"
                active={isCommitteeActive}
              >
                <NavDropdown.Item href="#executive">Executive Committee</NavDropdown.Item>
                <NavDropdown.Item href="#scientific">Scientific Committee</NavDropdown.Item>
              </NavDropdown>

             
              <Nav.Link href="#speakers" active={activeSection === "speakers"}>Speakers</Nav.Link>
              <Nav.Link href="#sponsors" active={activeSection === "sponsors"}>Sponsors</Nav.Link>
              <Nav.Link href="#social" active={activeSection === "social"}>Social</Nav.Link>
              <Nav.Link href="#contact" active={activeSection === "contact"}>Contact</Nav.Link>
               <Nav.Link href={programmePDF} download="VetEd_Africa_Scientific_Program.pdf">Program</Nav.Link>
              
              <NavDropdown title="Accommodation" id="more-dropdown">
                <NavDropdown.Item href="https://fr.hotels.com/re674695912684032000/hotels-region-rabat-maroc/?semcid=HCOM-AF.UB.GOOGLE.DL-DSA-c-FR.HOTEL&semdtl=a115386150310.b1129470758039.g1dsa-1243122942421.e1c.m1CjwKCAiA2JG9BhAuEiwAH_zf3nLGOLjkTmguUCutoC3JQiYvyE2jt50W1sKlx3JLqTNRrqV1C-JR-BoCYtAQAvD_BwE.r1.c14ZKe86fkh9uFq3bvq75wvw.j11009984.k1.d1660231082221.h1.i1113027323750.l1.n1.o1.p1.q1.s1.t1.x1.f1.u1.v1.w1&gad_source=1&gclid=CjwKCAiA2JG9BhAuEiwAH_zf3nLGOLjkTmguUCutoC3JQiYvyE2jt50W1sKlx3JLqTNRrqV1C-JR-BoCYtAQAvD_BwE" target="_blank" rel="noopener noreferrer">
                  Hotels in Rabat
                </NavDropdown.Item>
                <NavDropdown.Item href="https://fr.airbnb.com/a/stays/Morocco?c=.pi0.pk193019135_81811731747&gclsrc=aw.ds&&c=.pi0.pk193019135_81811731747&localized_ghost=true&gad_source=1&gclid=CjwKCAiA2JG9BhAuEiwAH_zf3jT80BnRj4n55Ii77lL7Mce99SklSo3-zKFao8ugR7xVH788WrYN5hoC2isQAvD_BwE" target="_blank" rel="noopener noreferrer">
                  Airbnb Morocco
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Page Sections */}
      <div id="home"><Home /></div>
      <div id="about"><About /></div> 
      <div id="registration"><Registration /></div> 
      <div id="abstract"><Abstract /></div> 
      <div id="book"><Book /></div> 
      <div id="executive"><Executive /></div>
      <div id="scientific"><Scientific /></div>
      <div id="speakers"><Speaker /></div> 
      <div id="sponsors"><Sponsors /></div> 
      <div id="social"><Social /></div>    
      <div id="contact"><Contact /></div>  
    </div>
  );
}

export default App;